<template>
  <ErrorBoundary>
    <label class="text-sm font-medium block mt-2">
      {{ $t('product.show.checkout.selectDate') }}
    </label>
    <Select
      v-model="selectedDate"
      class="mt-2 rounded-t-lg rounded-b-lg"
      :options="dates"
      :loading-more-options="publicEventDatePending"
      :transformer-fn="
        (option: EventDate, idx: number) => ({
          id: option.id,
          value: option,
          label: fnGetDateLabelHtml(option),
          disabled: !eventDateGetters.getDateIsOpen(option),
        })
      "
      size="small"
      :placeholder="$t('product.show.checkout.availableTimes')"
      @update:model-value="$emit('update-selected-date', selectedDate)"
    >
      <template #option="option">
        <client-only>
          <EventBuyBoxDateOption
            :option-data="option.value"
            :always-show-multidate="true"
            :show-collapse-button="false"
          />
        </client-only>
      </template>
    </Select>
  </ErrorBoundary>
</template>
<script setup lang="ts">
import type { EventDate } from '~/composables/types/event'
import {
  pickPreferredOrFirstAvailableDate,
  usePreferredDateIdFromQuery,
} from '~/composables/usePreferredDateIdFromQuery'
const { eventId } = defineProps<{ eventId: string }>()
const { fnGetDateLabelHtml } = useEventDateHelpers()
const selectedDate = ref<EventDate | undefined>(undefined)
const preferredDateId = usePreferredDateIdFromQuery()

const { pending: publicEventDatePending, accumulatedDates: dates } =
  await useFetchEventDates(eventId, {
    accumulateDates: true,
    query: {
      include: ['children'],
    },
  })

const emit = defineEmits(['update-selected-date'])

onMounted(() => {
  const dateToSelect = pickPreferredOrFirstAvailableDate(
    dates.value || [],
    preferredDateId.value
  )

  if (dateToSelect) {
    selectedDate.value = dateToSelect
    emit('update-selected-date', dateToSelect)
  }
})
</script>
